import type { SearcherLimitDto, SearcherLimitsDto, YandexGraphsDto } from './dto';
import type { RepeatedQuery, SearcherLimit, YandexGraphs } from './types';

export function toYandexGraphs(dto: YandexGraphsDto): YandexGraphs {
    const repeats: RepeatedQuery[] = [];

    for (const [count, queries] of Object.entries(dto?.hovertext_dict ?? {})) {
        if (!Array.isArray(queries)) continue;
        queries.forEach((query, index) => {
            repeats.push({ id: `${count}-${index}`, count: Number(count) || 0, query });
        });
    }

    repeats.sort((a, b) => b.count - a.count);

    return {
        searcherHtml: dto?.graph_searcher_html ?? '',
        gptHtml: dto?.graph_gpt_html ?? '',
        repeats,
    };
}

function toSearcherLimit(dto: SearcherLimitDto, index: number): SearcherLimit {
    const inn = dto.inn === null || dto.inn === undefined ? '' : String(dto.inn);

    return {
        id: inn || `row-${index}`,
        name: dto.name?.trim() || '—',
        inn: inn || '—',
        searcherCount: dto.searcher_request_counts ?? 0,
        gptOptimizerCount: dto.gpt_optimizer_count ?? 0,
        gptFilterCount: dto.gpt_filter_count ?? 0,
    };
}

export function toSearcherLimits(dto: SearcherLimitsDto): SearcherLimit[] {
    return Array.isArray(dto?.report_data) ? dto.report_data.map(toSearcherLimit) : [];
}